import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Notebox(props) {
    return (
        <div className="p-100 pb-0">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="boxes_item text-center">
                            <Row>
                                <Col xs={12} md={10} lg={8} xl={8} xxl={8} className="m-auto">
                                    <h2>Corporate Learning & Development Software Yields Huge ROEI</h2>
                                    <p>The usage of Learning management systems in corporate organizations and academic
                                        institutions has surged drastically post-pandemic, with a market size
                                        of <strong>$16.19</strong> billion.</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Notebox;